import React from "react";
import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  Grid,
  Button,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Stack,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const AboutSection = styled(Box)(({ theme }) => ({
  padding: "1.5rem 0",
  backgroundColor: "#fff",
  textAlign: "center",
  maxWidth: '1200px',
  margin: "auto"

}));

const AboutTitle = styled(Typography)(({ theme }) => ({
  fontSize: "48px",
  marginBottom: "30px",
  color: "#333",
  fontWeight: "500",
}));

const AboutText = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  lineHeight: "1.8",
  color: "#666",
  // maxWidth: '1200px',
  margin: "0 auto",
  padding: "0 20px",
}));

const About = () => {
  return (
    <AboutSection component="section" id="about">
      <>
        {/* Main Title */}
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
          color="rgba(26,128,200)"

        >
          About Us{" "}
        </Typography>

        {/* About Section */}
        <Box sx={{ mb: 4 }}>
          <CardContent>
            <Typography textAlign={{ xs: "start", md: "justify" }} variant="body1" color="text.secondary">
              Hamsa-Lomi: Supporting Our Community Through Tradition and
              Compassion. In the heart of Nashville, Tennessee, the Ethiopian
              community recognized a profound need to create a self-help
              association that could provide comfort and financial support to
              those facing the loss of a loved one. Rooted in Ethiopian culture,
              Hamsa-Lomi was established to ease the financial burden of funeral
              expenses while offering emotional and personal assistance during
              the mourning process.{" "}
            </Typography>
            <Typography textAlign={{ xs: "start", md: "justify" }} variant="body1" color="text.secondary" mt={2}>
              Founded in 2014 by dedicated Ethiopian volunteers in Nashville,
              Hamsa-Lomi embodies the rich traditions of communal care and
              mutual support that have been passed down through generations in
              Ethiopia. From its inception, the association has been guided by a
              strong By-law, with seven elected Board members overseeing its
              operations and ensuring the organization serves its mission
              effectively. Today, Hamsa-Lomi is proud to have grown into a
              community of over 900 members, united by a shared commitment to
              providing solace and support to families during their most
              difficult times. The Board members work tirelessly, taking on
              various responsibilities in accordance with the By-law to ensure
              the smooth functioning of the organization. We warmly invite
              individuals in the Nashville area to join Hamsa-Lomi and help
              preserve the age-old Ethiopian tradition of mutual assistance.
              Together, we can continue this legacy of compassion and collective
              support.{" "}
            </Typography>
          </CardContent>
        </Box>

        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
          color="rgba(26,128,200)"

        >
          Our Motto and Mission{" "}
        </Typography>

        {/* About Section */}
        <Box sx={{ mb: 4 }}>
          <CardContent>
            <Typography textAlign={{ xs: "start", md: "justify" }} variant="body1" color="text.secondary">
              Hamsa-Lomi operates with the following guiding principles:
              Financial Assistance: Providing funds for funeral services,
              including transportation of the deceased to their final resting
              place. Communication: Notifying members promptly in the event of a
              member's passing and disseminating necessary information. Hamsa
              Lomi About Us Section 1 Coordination: Organizing tasks related to
              funerals and mourning processes, ensuring cultural traditions are
              upheld. Emotional Support: Encouraging members to participate in
              mourning activities and console the bereaved family. Guidance:
              Offering families information about funeral arrangements and
              transportation services for the deceased. Adaptation: Expanding
              objectives as needed to meet the evolving needs of our members.
            </Typography>
          </CardContent>
        </Box>

        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
          color="rgba(26,128,200)"
        >
          What Does Hamsa-Lomi Mean?
        </Typography>

        {/* About Section */}
        <Box sx={{ mb: 4 }}>
          <CardContent>
            <Typography textAlign={{ xs: "start", md: "justify" }} variant="body1" color="text.secondary">
              The name "Hamsa-Lomi" is derived from the Amharic language, where
              it literally translates to "Fifty Lemons." It comes from an
              Ethiopian proverb: “Fifty lemons are a burden for one person but
              an aroma for fifty people.” This phrase beautifully captures the
              essence of collective effort, shared responsibility, and the
              strength of community, a philosophy that underpins everything we
              do. Hamsa Lomi is more than an organization; it is a reflection of
              Ethiopian culture and a testament to the power of unity. Join us
              in continuing this vital tradition and making a meaningful impact
              in the lives of our members and their families.
            </Typography>
          </CardContent>
        </Box>
      </>
    </AboutSection>
  );
};

export default About;
